/* ==========================================================================
   header.js — Foundation Theme
   Mobile nav drawer, accordion, scroll detection, cart badge sync.
   ========================================================================== */

(function () {
  'use strict';

  /* ── Mobile nav drawer ──────────────────────────────────────────────── */
  var drawer   = document.getElementById('mob-nav');
  var panel    = drawer && drawer.querySelector('.mob-nav__panel');
  var backdrop = drawer && drawer.querySelector('.mob-nav__backdrop');
  var closeBtn = drawer && drawer.querySelector('.mob-nav__close');
  var openBtn  = document.querySelector('.hdr-hamburger');

  function drawerOpen() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mob-nav-open');
    openBtn.setAttribute('aria-expanded', 'true');
    setFocusable(panel, true);
    setTimeout(function () {
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }, 60);
  }

  function drawerClose() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mob-nav-open');
    openBtn.setAttribute('aria-expanded', 'false');
    setFocusable(panel, false);
    if (openBtn) openBtn.focus();
  }

  function setFocusable(container, on) {
    container.querySelectorAll('a, button').forEach(function (el) {
      if (!on && el.classList.contains('mob-nav__close')) return;
      on ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1');
    });
    if (on) {
      container.querySelectorAll('.mob-nav__sub[hidden] a').forEach(function (a) {
        a.setAttribute('tabindex', '-1');
      });
    }
  }

  if (drawer && openBtn) {
    setFocusable(panel, false);
    openBtn.addEventListener('click', drawerOpen);
    if (closeBtn) closeBtn.addEventListener('click', drawerClose);
    if (backdrop) backdrop.addEventListener('click', drawerClose);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') drawerClose();
    });
  }

  /* ── Accordion ──────────────────────────────────────────────────────── */
  if (drawer) {
    drawer.querySelectorAll('.mob-nav__acc').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub      = document.getElementById(this.getAttribute('aria-controls'));
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        sub.hidden = expanded;
        sub.querySelectorAll('a').forEach(function (a) {
          expanded ? a.setAttribute('tabindex', '-1') : a.removeAttribute('tabindex');
        });
      });
    });
  }

  /* ── Scroll detection (sticky shadow) ────────────────────────────── */
  var header  = document.getElementById('site-header');
  var spacer  = document.querySelector('.site-header-spacer');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var scrolled = window.scrollY > 20;
          header.classList.toggle('is-scrolled', scrolled);
          if (spacer) spacer.classList.toggle('is-active', scrolled);
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Cart badge sync ────────────────────────────────────────────────── */
  /* cart-drawer.js calls refreshCartCount() which updates [data-cart-count]
     directly. We only need to handle the bounce animation here.           */
  var badge = document.querySelector('[data-cart-count]');
  if (badge) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'characterData' || m.type === 'childList') {
          var count = parseInt(badge.textContent, 10) || 0;
          badge.classList.toggle('is-hidden', count === 0);
          badge.classList.remove('is-updated');
          void badge.offsetWidth;
          badge.classList.add('is-updated');
        }
      });
    });
    observer.observe(badge, { characterData: true, childList: true, subtree: true });
  }

}());

